import React from "react";
import { Switch, Route } from "react-router-dom";

import Home from "../../home/home.js";
import Solutions from "../../solutions/solutions.js";
import Solutions1 from "../../solutions1/solutions1.js";
import Solutions2 from "../../solutions2/solutions2.js";
import Description from "../../description/description.js";
import News from "../../news/news.js";
import Heatmeters from "../../heatmeters/heatmeters.js";
import Articles from "../../articles/articles.js";
import Connection from "../../connection/connection.js";
import AppForContract from "../../connection/application_for_contract/application.js";
import AppForEquipment from "../../connection/application_for_equipment/application.js";
import AppForConnect from "../../connection/application_for_connect/application.js";
import Tariffs from "../../tariffs/tariffs.js";
import Licenses from "../../licenses/licenses.js";
import Partners from "../../partners/partners.js";
import Contacts from "../../contacts/contacts.js";
import DeviceSetting from "../../device_setting/deviceSetting.js";
import Login from "../../login/login.js";
import Feedback from "../../feedback/feedback.js";
import { Nomatch } from "../../nomatch/nomatch.js";

import styles from "./content.module.css";


//// A wrapper for <Route> that redirects to the login
//// screen if you're not yet authenticated.
//function PrivateRoute({ children, isLogged, login, recoverPassword, demoEnter,  ...rest }) {
//    console.log(children);
//    console.log(login);
//    return (
//        <Route exact path="/login"
//            render={props => (
//                isLogged ? (
//                    children
//                ) : (
//                <Login
//                    {...props}
//                    login={login}
//                    recoverPassword={recoverPassword}
//                    demoEnter={demoEnter}
//                />)
//            )}
//        />
//    );
//}

//function PrivateRoute({ children, isLogged, login, recoverPassword, demoEnter, ...rest }) {
//    return (
//        <Route exact path="/login"
//            render={props => (
//                <Login
//                    {...props}
//                    login={login}
//                    recoverPassword={recoverPassword}
//                    demoEnter={demoEnter}
//                />
//            )}
//        />
//    );
//}

//function PrivateRoute({ children, isLogged, ...rest }) {
//    return (
//        <Route
//            {...rest}
//            render={() =>
//                isLogged ? (
//                    children
//                ) : (
//                        <Redirect
//                            to={{
//                                pathname: "/login",
//                                state: {}
//                            }}
//                        />
//                    )
//            }
//        />
//    );
//}

//<PrivateRoute exact path={this.props.workSiteLink}
//    isLogged={this.props.isLogged}
//    login={this.props.login}
//    recoverPassword={this.props.recoverPassword}
//    demoEnter={this.props.demoEnter} />


class Content extends React.Component {
  render() {
    return (
      <div
        className={styles.content}
        style={{
          marginLeft: this.props.menuExtended ? "8.7vw" : "0vw"
        }}
      >
        <Switch>
          <Route exact path="/"
            render={props => (
              <Home
                    {...props}
                    showModal={this.props.showModal}
                demoEnter={this.props.demoEnter}
                menuExtended={this.props.menuExtended}
                currentSlideHandler={this.props.carouselCurrentSlideHandler}
              />
            )}
          />
          <Route exact path="/solutions" component={Solutions} />
          <Route exact path="/solutions1" component={Solutions1} />
          <Route exact path="/solutions2" component={Solutions2} />
          <Route exact path="/description" component={Description} />
          <Route exact path="/news" component={News} />
                <Route exact path="/hmeters"
                    render={props => (
                        <Heatmeters {...props} showModal={this.props.showModal} />
                    )}
                />
          <Route exact path="/articles" component={Articles} />
          <Route exact path="/connection" component={Connection} />
          <Route exact path="/zayv_na_uslugi" component={AppForContract} />
          <Route exact path="/zayv_na_obor" component={AppForEquipment} />
          <Route exact path="/zayv_na_vstr" component={AppForConnect} />
          <Route exact path="/tariffs" component={Tariffs} />
            <Route exact path="/licenses"
                render={props => (
                    <Licenses {...props} showModal={this.props.showModal} />
                    )}
            />
          <Route exact path="/partners" component={Partners} />
                <Route exact path="/contacts" component={Contacts} />
           <Route exact path="/login"
            render={props => (
              <Login
                {...props}
                login={this.props.login}
                recoverPassword={this.props.recoverPassword}
                demoEnter={this.props.demoEnter}
              />
            )}
          />
          <Route exact path="/tutorial" component={DeviceSetting} />
          <Route exact path="/feedback" component={Feedback} />
          <Route component={Nomatch} />
        </Switch>
      </div>
    );
  }
}

export default Content;
